import Banner from "../../components/banner";
import SectionCard from "../../components/SectionCard";
import QuestionBlock from "../../components/QuestionBlock";
import "../../styles/style.css";
import { useState } from "react";
import Step1 from "../../steps/Step1";
import Step2 from "../../steps/Step2";
import Step3 from "../../steps/Step3";
import Step4 from "../../steps/Step4";
import Step5 from "../../steps/Step5";
import Step6 from "../../steps/Step6";
import Step7 from "../../steps/Step7";
import SuccessMessage from "../../components/SuccessMessage";
import StepBar from "../../components/StepBar";

export default function Questionario() {

    const [step, setStep] = useState(0);

  const [formData, setFormData] = useState({
    nomeResponsavel: "",
    idade: "",
    telefone: "",
    cpf:"",
    parentesco: "",
    escolaridade:"",
    pessoasResidencia:"",
    criancasResidencia:"",
    fonteRenda:"",
    rendaMensal:"",
    beneficio:"",
    ocupacao:"",
    imovel:"",
    tipoMoradia:"",
    abastecimentoAguaPublica:"",
    coletaEsgoto:"",
    deficienteResidencia:"",
    teaResidencia:"",
    coletaLixo:"",
    ruaPavimentada:"",
    energia:"",
    internet:"",
    temaPrefeituraInvestir:"",
    quantasVezesCriancaAdolescentesAlimentamDia:"",
    rotinaAlimentacaoFora:""
  });

  function updateData(newData) {
    setFormData((old) => ({ ...old, ...newData }));
  }

  function next() {
    if (step === 6) {
      // 👉 Enviar o formulário AQUI
    finish();
    fetch("https://api-questionario-8skvsb7n3-antoniop87s-projects.vercel.app/enviar", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(formData),
})

 
      // 👉 Depois mostrar a tela final
      setStep("final");
    } else {
      setStep(step + 1);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });

  }

  function back() {
    setStep((s) => s - 1);
  }

  function finish() {
    console.log("Formulário finalizado:", formData);
    // alert("Formulário enviado!");
  }

  return (
    <div className="page-container mt-4" style={{background:"#FAFDFF"}}>

      <Banner />

      {step === 0 && (
        <Step1 data={formData} onChange={updateData} onNext={next} />
      )}

      {step === 1 && (
        <Step2
          data={formData}
          onChange={updateData}
          onNext={next}
          onBack={back}
        />
      )}

      {step === 2 && (
        <Step3
          data={formData}
          onChange={updateData}
          onNext={next}
          onBack={back}
        />
      )}

       {step === 3 && (
        <Step4
          data={formData}
          onChange={updateData}
          onNext={next}
          onBack={back}
        />
      )}
      {step === 4 && (
        <Step5
          data={formData}
          onChange={updateData}
          onNext={next}
          onBack={back}
        />
      )}
      {step === 5 && (
        <Step6
          data={formData}
          onChange={updateData}
          onNext={next}
          onBack={back}
        />
      )}
      {step === 6 && (
        <Step7
          data={formData}
          onChange={updateData}
          onNext={next}
          onBack={back}
        />
      )}

      {step === "final" && <SuccessMessage />}


{step !== "final" && <StepBar current={step} />}

    </div>
  );
}